import React from 'react';
import Modal from '../helpers/Modal';
import { BuildData } from '../../types';
import SavedBuildsTab from './SavedBuildsTab';

interface LoadBuildModalProps {
    isOpen: boolean;
    onClose: () => void;
    builds: BuildData[];
    onLoadBuild: (build: BuildData) => void;
    onDeleteBuild: (id: string) => void;
    onUpdateBuild: (id: string, updates: Partial<BuildData>) => void;
    onExportBuild: (build: BuildData) => void;
    onImportBuild: (buildData: Omit<BuildData, 'id' | 'createdAt' | 'updatedAt'>) => void;
    onDuplicateBuild: (build: BuildData) => void;
    currentBuildId: string | null;
}

const LoadBuildModal: React.FC<LoadBuildModalProps> = (props) => {
    return (
        <Modal isOpen={props.isOpen} onClose={props.onClose} title="Load / Manage Builds" size="2xl">
            <SavedBuildsTab
                builds={props.builds}
                currentBuildId={props.currentBuildId}
                onLoadBuild={props.onLoadBuild}
                onDeleteBuild={props.onDeleteBuild}
                onUpdateBuild={props.onUpdateBuild}
                onExportBuild={props.onExportBuild}
                onImportBuild={props.onImportBuild}
                onDuplicateBuild={props.onDuplicateBuild}
            />
        </Modal>
    );
};

export default LoadBuildModal;